import { Github, ExternalLink } from "../../component/Icons";

export const data = [
  {
    id: 1,
    name: "AI Library",
    stacks: [
      {
        name: "",
      },
      {
        name: "",
      },
      {
        name: "",
      },
      {
        name: "",
      },
    ],
    links: [
      {
        name: "ext-link",
        href: "https://www.theailibrary.co/",
        icon: <ExternalLink />,
      },
    ],
  },
  {
    id: 2,
    name: "Career Impact Now",
    stacks: [
      {
        name: "react",
      },
      {
        name: "tailwindcss",
      },
    ],
    links: [
      {
        name: "ext-link",
        href: "https://careerimpactnow.com/",
        icon: <ExternalLink />,
      },
    ],
  },
  {
    id: 3,
    name: "My Technical Blog",
    stacks: [
      {
        name: "nextjs",
      },
      {
        name: "typescript",
      },
      {
        name: "tailwindcss",
      },
      {
        name: "markdown",
      },
    ],
    links: [
      {
        name: "github",
        href: "https://github.com/FesoQue/uncaught-md-blog",
        icon: <Github />,
      },
      {
        name: "ext-link",
        href: "https://qwrites.vercel.app/",
        icon: <ExternalLink />,
      },
    ],
  },
  {
    id: 4,
    name: "EvergreenFFX Website",
    stacks: [
      {
        name: "",
      },
      {
        name: "",
      },
      {
        name: "",
      },
      {
        name: "",
      },
      {
        name: "",
      },
    ],
    links: [
      {
        name: "ext-link",
        href: "https://evergreenffx.com/",
        icon: <ExternalLink />,
      },
    ],
  },
  {
    id: 5,
    name: "The Creative Ally Website",
    stacks: [
      {
        name: "react",
      },
      {
        name: "css",
      },
      {
        name: "framer-motion",
      },
    ],
    links: [
      {
        name: "ext-link",
        href: "https://thecreativeally.com/",
        icon: <ExternalLink />,
      },
    ],
  },
  {
    id: 6,
    name: "Space Tourism Website",
    stacks: [
      {
        name: "nextjs",
      },
      {
        name: "tailwindcss",
      },
      {
        name: "api",
      },
    ],
    links: [
      {
        name: "github",
        href: "https://github.com/FesoQue/Space-Tourism-Website",
        icon: <Github />,
      },
      {
        name: "ext-link",
        href: "https://space-tourism-website-liart.vercel.app/",
        icon: <ExternalLink />,
      },
    ],
  },
];
